import { PersonSettlementTourType } from '@api';
import {
  TouringCard,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
  TouringDataTable,
} from '@common';
import { useTranslation } from 'react-i18next';
import { usePersonSettlementsColumns } from './hooks';

type PersonSettlementsTablePropsType = {
  settlements: PersonSettlementTourType[];
};

export const PersonSettlementsTable: React.FC<
  PersonSettlementsTablePropsType
> = ({ settlements }) => {
  const { t } = useTranslation('personDetailsSettlements');
  const { columns } = usePersonSettlementsColumns();

  return (
    <TouringCard data-testid="person-settlements-container">
      <TouringCardHeader>
        <TouringCardTitle>{t('TITLE')}</TouringCardTitle>
      </TouringCardHeader>
      <TouringCardSection>
        <TouringDataTable<PersonSettlementTourType>
          records={settlements}
          columns={columns}
          withTableBorder={false}
          withColumnBorders={false}
          highlightOnHover={false}
        />
      </TouringCardSection>
    </TouringCard>
  );
};
